import './saved-listings.css';
import React, { useRef, useState } from 'react';
import { IListings } from '../../models/listings.model';
import DataContainer from '../data-container';
import Results from '../results/results';
import { IListing } from '../../models/listing.model';
import { iconBookmarkSolid } from '../../util/icons';

export interface SavedListingsProps {
  savedListings: IListings;
  activePreviewListingId: string;
  isSavedListing(value: string): boolean;
  setActivePreviewListingId(value: string): void;
  addSavedListing(value: IListing | null): void;
  removeSavedListing(value: IListing | null): void;
}

export const SavedListings: React.FC<SavedListingsProps> = (props: SavedListingsProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState('priceAsc');
  const containerRef = useRef<HTMLDivElement | null>(null);
  /*
    const handleClickOutside = (event: any) => {
      const clickedElement = document.elementFromPoint(event.clientX, event.clientY);
  
      if (clickedElement !== null && (clickedElement.classList.contains('listing-details-container') || clickedElement.closest('.listing-details-container') || clickedElement.closest('.header'))) {
        // intentionally empty
      } else if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
  
    useEffect(() => {
      isOpen
        ? document.addEventListener("click", handleClickOutside)
        : document.removeEventListener("click", handleClickOutside);
      return () => {
        isOpen &&
          document.removeEventListener("click", handleClickOutside);
      };
    }, [isOpen]);
  */
  return (
    <div className="saved-listings-container" ref={ref => (containerRef.current = ref)}>
      <button className={isOpen ? 'filter-button filter-button-selected' : 'filter-button'} onClick={() => setIsOpen(!isOpen)}>
        <span className="icon-saved">{iconBookmarkSolid}</span> <span className="xl-wide-screen">Saved Listings</span> ({props.savedListings.total})
      </button>
      {isOpen &&
        <div className="saved-listings">
          <DataContainer>
            <Results
              title="Saved Listings"
              listings={props.savedListings}
              sortBy={sortBy}
              activePreviewListingId={props.activePreviewListingId}
              isSavedListing={props.isSavedListing}
              setSortBy={setSortBy}
              addSavedListing={props.addSavedListing}
              removeSavedListing={props.removeSavedListing}
              setActivePreviewListingId={props.setActivePreviewListingId}
            />
          </DataContainer>
        </div>
      }
    </div>
  );
}

export default SavedListings;
